import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { FinalCTA } from "@/components/landing/Sections";

export const Route = createFileRoute("/sesiones")({
  head: () => ({
    meta: [
      { title: "Sesiones · SUSIEDAD" },
      {
        name: "description",
        content: "Las sesiones oficiales de SUSIEDAD se publicarán próximamente.",
      },
    ],
  }),
  component: () => (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main>
        <section className="border-b border-border px-5 py-28 lg:px-8 lg:py-40">
          <div className="mx-auto max-w-4xl">
            <p className="eyebrow">Sesiones</p>
            <h1 className="display-xl mt-5">Próximamente.</h1>
            <p className="mt-7 max-w-xl text-lg leading-relaxed text-muted-foreground">
              Esta sección se abrirá cuando estén disponibles las sesiones oficiales. Hasta
              entonces, cuéntame qué celebración estás preparando y diseñamos su sonido.
            </p>
          </div>
        </section>
        <FinalCTA />
      </main>
      <SiteFooter />
    </div>
  ),
});
